module.exports = __webpack_public_path__ + "img/swap-root-dagger.30f3de6a.svg";